export default {
  setNotifications(state, notificationList) {
    state.notifications = notificationList
  }
}
